// extracted by mini-css-extract-plugin
module.exports = {"section":"_1L6L_N"};